import StantMultiselect from"../../utils/stant_multiselect.coffee"

$(document).on 'turbolinks:load', ->
  new StantMultiselect('report-inspection-images-manageable-services-multiselect').add_listener()